import { render, staticRenderFns } from "./centercontain.vue?vue&type=template&id=9e7c3a48&scoped=true"
import script from "./centercontain.vue?vue&type=script&lang=js"
export * from "./centercontain.vue?vue&type=script&lang=js"
import style0 from "./centercontain.vue?vue&type=style&index=0&id=9e7c3a48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e7c3a48",
  null
  
)

export default component.exports